export const isFocusable = element => {
  if (element.inert) {
    return false
  }
  if (element.tabIndex < 0) {
    return false
  }
  if (element.disabled) {
    return false
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel != 'ignore'
    case 'INPUT':
      return element.type != 'hidden'
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true
    default:
      return false
  }
}

/**
 * Set Attempt to set focus on the current node.
 *
 * @param element The node to attempt to focus on.
 * @returns {boolean} true if element is focused.
 */
export const attemptFocus = element => {
  if (!isFocusable(element)) {
    return false
  }
  try {
    element.focus()
  } catch (e) {
    // continue regardless of error
  }
  return document.activeElement === element
}

/**
 * Find the last descendant node that is focusable.
 *
 * @param element DOM node for which to find the last focusable descendant.
 * @returns {boolean} true if a focusable element is found and focus is set.
 * @since KJS-3902
 */
export const focusFirstDescendant = element => {
  for (let i = 0; i < element.childNodes.length; ++i) {
    const child = element.childNodes[i]
    if (child instanceof Element && child.getAttribute('inert')) continue
    if (attemptFocus(child) || focusFirstDescendant(child)) {
      return true
    }
  }
  return false
}

/**
 * Find the last descendant node that is focusable.
 *
 * @param element DOM node for which to find the last focusable descendant.
 * @returns {boolean} true if a focusable element is found and focus is set.
 * @since KJS-3902
 */
export const focusLastDescendant = element => {
  for (let i = element.childNodes.length - 1; i >= 0; --i) {
    const child = element.childNodes[i]
    if (child instanceof Element && child.getAttribute('inert')) continue
    if (attemptFocus(child) || focusLastDescendant(child)) {
      return true
    }
  }
  return false
}
